import React from 'react';
import { Divider } from '../Divider';
import './ContentBlockSimpleDivider.scss';
export const ContentBlockSimpleDivider = () => React.createElement(Divider, { className: "content-block-simple-divider" });
